import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';

import Button from '@material-ui/core/Button';

const styles = () => ({
    dismissButton: {
        color: '#fff',
    },
});

export const DismissButton = withStyles(styles)(({ classes, snackBarId }) => {
    const { closeSnackbar } = useSnackbar();
    return (
        <Button
            key={'dismiss'}
            className={classes.dismissButton}
            size="small"
            onClick={() => closeSnackbar(snackBarId)}
        >
            Dismiss
        </Button>
    );
});
